export const applyWordSpacing = (text, wordSpacing = 1) => {
    const parsedWordSpacing = Number(wordSpacing);
    const spacesCount = Number.isFinite(parsedWordSpacing)
        ? Math.max(1, Math.floor(parsedWordSpacing))
        : 1;

    if (spacesCount === 1) {
        return text;
    }

    return text.replace(/[^\S\r\n]+/g, ' '.repeat(spacesCount));
};